<template>
    <nav class="navbar navbar-static navbar-inverse">
        <div class="container-fluid">
            <div class="navbar-header">
                <button class="navbar-toggle collapsed" type="button" @click="showNavItems" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
            </div>
            <div id="navbar" class="navbar-collapse collapse">
                <ul class="nav navbar-nav">
                    <ul class="nav navbar-nav">
                        <li><a href="./#/search">Home</a></li>
                        <li v-show="this.$store.getters.getUserStatus === 'Admin'"><a href="./#/reports">Reports</a></li>
                    </ul>
                </ul>
                <ul class="nav navbar-nav navbar-right" v-if="this.$store.getters.getUserName !== 'username'">
                    <li class="dropdown" @click="showDropDown($event.currentTarget)"><a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="glyphicon glyphicon-user"></span> {{this.$store.getters.getUserName}}<span class="caret"></span></a>
                    </li>
                    <ul class="dropdown-menu">
                        <li><a href="./#/userMaintenance">User Maintenance</a>
                            <hr v-show="this.$store.getters.getUserStatus === 'Admin'"></li>
                        <li v-show="this.$store.getters.getUserStatus === 'Admin'"><a href="./#/adminMaintenance">Admin Maintenance</a></li>
                    </ul>
                    <li class="navbar-right"><a href="./"><span class="glyphicon glyphicon-log-out"></span> Logout</a></li>
                </ul>
            </div>
        </div>
        <div id="hideDropdown" @click="hideDropDown" v-show="showDropDownBackDrop"></div>
    </nav>
</template>

<script>
  export default {
    name: 'nav-bar',
    data () {
      return {
        showDropDownBackDrop: false
      }
    },
    methods: {
      showNavItems () {
        let navbar = document.querySelector('#navbar')
        if (navbar.classList.contains('collapse')) {
          navbar.classList.remove('collapse')
        } else {
          navbar.classList.add('collapse')
        }
      },
      showDropDown (element) {
        let dropDownMenu = element.parentNode.getElementsByClassName('dropdown-menu')[0]
        if (dropDownMenu.style.display === 'block') {
          dropDownMenu.style.display = 'none'
        } else {
          dropDownMenu.style.display = 'block'
        }
        this.showDropDownBackDrop = true
      },
      hideDropDown () {
        let dropDownsMenu = document.getElementsByClassName('dropdown-menu')
        for (let i = 0; i < dropDownsMenu.length; i++) {
          dropDownsMenu[i].style.display = 'none'
        }
        this.showDropDownBackDrop = false
      }
    },
    beforeMount () {
      this.checkSession()
    }
  }
</script>

<style scoped>
    #hideDropdown{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/navBar.vue